var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#instagram_svg__clip0)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 23.16a3.16 3.16 0 100-6.32 3.16 3.16 0 000 6.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.042 12.013h-8.084a3.947 3.947 0 00-3.947 3.948v8.081a3.947 3.947 0 003.947 3.947h8.084a3.947 3.947 0 003.947-3.947v-8.084a3.947 3.947 0 00-3.947-3.945zM20 25.173A5.175 5.175 0 1125.171 20 5.179 5.179 0 0120 25.174zm5.203-9.068a1.278 1.278 0 11-.006-2.556 1.278 1.278 0 01.006 2.556z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0a20 20 0 100 40 20 20 0 000-40zm10 24.042A5.963 5.963 0 0124.042 30h-8.084A5.966 5.966 0 0110 24.042v-8.084A5.966 5.966 0 0115.958 10h8.084A5.966 5.966 0 0130 15.958v8.084z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "instagram_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
}
export default SvgInstagram;